import { render } from "./syntheseProjet.vue?vue&type=template&id=0ee51b39"
import script from "./syntheseProjet.vue?vue&type=script&lang=ts"
export * from "./syntheseProjet.vue?vue&type=script&lang=ts"
script.render = render

export default script